import { JOURNEY_OT_LOAD_STATE, JOURNEY_OT_STATES, JOURNEY_OT_UNLOAD_STATE } from "../../features/journeys/utils";
import { ID, isOutdated } from "../../features/core/utils";
import { Marker } from "../core/models";
import { LastReportFilters } from "./utils";

export const filterLastReportMarkers = (markers: Marker[], activeFilters: LastReportFilters) => {
    let { vehicleTypes, vehicleStates, filterWithRecentActivity, filtersWithLoad } = activeFilters;

    // console.log("actividad en filtros", {
    //     vehicle_types: vehicleTypes,
    //     vehicle_states: vehicleStates,
    //     with_recent_activity: filterWithRecentActivity,
    //     filtersWithLoad: filtersWithLoad
    // });

    let filteredVehicleIds:ID[] = [];

    let filteredMarkers = markers.filter(marker => {
        let passFilter = true; // Variable to track if the marker passes all filters
    
        // Filter by vehicle type
        if (vehicleTypes.length > 0) {
            let markerVehicleType = -1;
            if (marker.infoState) {
                markerVehicleType = marker.infoState.vehicle_type;
            }
            if (!vehicleTypes.includes(markerVehicleType)) {
                passFilter = false;
            }
        }
    
        // Filter by vehicle state
        if(vehicleStates.length > 0){
            let markerVehicleState: number = -1;
            if (marker.infoState && marker.infoState.vehicle_state && marker.infoState.vehicle_state['value']) {
                markerVehicleState = marker.infoState.vehicle_state['value'];
            }
            if (!vehicleStates.includes(markerVehicleState)) {
                passFilter = false;
            }

        }
        
    
        // Filter by recent activity
        if (filterWithRecentActivity && marker.infoState && marker.infoState.timestamp) {
            if (isOutdated(marker.infoState.timestamp)) {
                // console.log(`${marker.infoState.timestamp} timestamp outdated`)
                passFilter = false;
            }
        }

        if (filtersWithLoad) {
            if (marker && marker.infoState && marker.infoState.work_order_load_state === JOURNEY_OT_UNLOAD_STATE) {
                passFilter = false;
            }
        }
    
        // If the marker passes all filters, push its ID to the filteredVehicleIds array
        if (passFilter && marker.info) {
            filteredVehicleIds.push(marker.info.id);
        }
    
        // Return whether the marker passes the filters
        return passFilter;
    })

    return {
        filteredMarkers: filteredMarkers,
        filteredVehicleIds: filteredVehicleIds
    }
}

